import {
    ADDRESS_LIST,
    ADDRESS_PAGINATION
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';
import { de } from 'date-fns/locale';

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getAddressBookList = (payload) => {
    return dispatch => {
        // const queryParams = new URLSearchParams({
        //     ...payload,
        // }).toString();

         const queryParams = new URLSearchParams({
            ...payload,
        }).toString().replace(/\+/g, '%20');
        const url = `v1/AddressBook/GetCompanyAddressList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === '201') {
                dispatch({
                    type: ADDRESS_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: ADDRESS_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getAddressByID = (payload) => {
    return dispatch => {
        const url = `v1/AddressBook/GetAddressByID?AddressId=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createAddressBook = (payload) => {
    const url = `v1/AddressBook/CreateAddressBook`;
    return APICall('post', payload, url).then(async result => {
        console.log('api data :',result);
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
             throw new Error(result?.data);
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const UpdateAddressBook = (payload) => {
    const url = `v1/AddressBook/UpdateAddressBook`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
              throw new Error(result?.data);
        }
    }, error => {
      
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const DeleteCompanyAddress = (payload) => {
   
   const url = `v1/AddressBook/DeleteCompanyAddress?AddressID=${payload}`;
    return APICall('post', null, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
          //  await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
        }, error => {
            return Promise.reject(error);
        });
    };

    /**
 * 
 * @param {*} payload 
 * @returns 
 */
export const UpdateAddressBookAddress = (payload) => {
    const url = `v1/AddressBook/UpdateAddressBook`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200|| result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createAddressBookAddress = (payload) => {
    const url = `v1/AddressBook/InsertAddress`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

export const getCPPositionList = () => {
       const url = `v1/Common/GetCPPositoinList`;   
       return APICall('get', {}, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {     
            // console.log("getCPPositionList",result);    
            return result;
        
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

export const getSelectedAccountAddress = (addressBookId, officeTypeId) => {
       const url = `v1/AddressBook/GetSelectedAccountAddress?addressBookId=${addressBookId}&officeTypeId=${officeTypeId}`;
      //const url = `v1/AddressBook/GetCPPositionList?addressBookId=${addressBookId}&officeTypeId=${officeTypeId}`;
    return APICall('get', {}, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {         
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const DocUpdatebyAddressbook = (payload) => {
    const url = `v1/AddressBook/UpdateSpecialNotes`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200|| result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const InsertComplianceCertification = (payload) => {
    const url = `v1/AddressBook/InsertComplianceCertification`;
    return APICall('post', payload, url).then(async result => {
        console.log("zzzzzzzzzzzzzzzzzzzzzz",result);
        if (result?.statuscode === 200|| result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const CreateAddressBookAccount = (payload) => {
    const url = `v1/AddressBook/CreateAddressBookAccount`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
           throw new Error("Error Generated While Inserting Comapny Address")
        }
    }, error => {
       throw new Error("Error Generated While Inserting Comapny Address")
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const GetComplianceCertificationByID = (payload) => {
    return dispatch => {
        const url = `v1/AddressBook/GetComplianceByID?CompanyId=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const GetAddressBookAccountByID = (payload) => {
    return dispatch => {
        const url = `v1/AddressBook/GetAddressBookAccountByID?companyid=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const DeleteAccountChargeById = (para) => {
   
        const url = `v1/AddressBook/DeleteAddressBookAccountCharges/?ChargesId=${para}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                  const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
                return result;
            } else {
                return false;
            }
        }, error => {
            return Promise.reject(error);
        });
    
};

 
export const GetCompanyAddressAdditionalDetails = (AddressId=0,MoveType) => {
    return dispatch => {
        const url = `v1/AddressBook/GetCompanyAddressAdditionalDetails?AddressId=${AddressId}&MoveType=${MoveType}`;
        return APICall('get', {}, url).then(result => {
            if ((result?.statuscode === 200 || result?.statuscode === 201) && result?.data?.length) {
                return result?.data?.[0];
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


export const UpdateCompanyAddressAdditionalDetails = (payload) => {
    const url = `v1/AddressBook/UpdateCompanyAddressAdditionalDetails`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200|| result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */


export const getCheckDuplicateCompanyist = (payload) => {
    return dispatch => {
        const companyName = encodeURIComponent(payload?.companyName ?? "");
        const masterCompanyId = encodeURIComponent(payload?.masterCompanyId ?? "");
        const url = `v1/AddressBook/CheckDuplicateCompany?companyName=${companyName}&masterCompanyId=${masterCompanyId}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                const data = result?.data;
                if (Array.isArray(data)) return data;
                if (Array.isArray(data?.companies)) return data.companies;
                if (Array.isArray(data?.list)) return data.list;
                return [];
            }
            return Promise.reject(new Error("Duplicate check failed"));
        }, error => Promise.reject(error));
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createAddressContact = (payload) => {
    const url = `v1/AddressBook/CreateAddressContact`;
    return APICall('post', payload, url).then(async result => {
        console.log('api createAddressContact :',result);
        if (result?.statuscode === 201 || result?.statuscode === 200) {
           
            return result;
        } else {
             throw new Error(result?.data);
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateAddressContact = (payload) => {
    const url = `v1/AddressBook/UpdateAddressContact`;
    return APICall('post', payload, url).then(async result => {
        console.log('api  :',result);
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
             throw new Error(result?.data);
        }
    }, error => {
        return error;
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getAddressContact = (payload) => {
        const url = `v1/AddressBook/GetAddressContact?Address_Id=${payload}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === '201') {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };


 /**
 * 
 * @param {*} payload 
 * @returns 
 */
export const deleteAddressContact = (para) => {
   
        const url = `v1/AddressBook/DeleteAddressContact/?contact_Id=${para}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result;
            } else {
                return false;
            }
        }, error => {
            return Promise.reject(error);
        });
    
};   


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const CreateUpdateCarrierContracts = (payload) => {
    const url = `v1/AddressBook/CreateUpdateCarrierContracts`;
    return APICall('post', payload, url).then(async result => {
        console.log('api data :',result);
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getAddressBookList(payList);
            return result;
        } else {
             throw new Error(result?.data);
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getCarrierContractsByCompanyid = (companyId) => {
    return dispatch => {
        const url = `v1/AddressBook/GetCarrierContracts?CompanyID=${companyId}`;
        return APICall('get', null, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};
